export const uiPaths = {
    assetFilesTempDownloadLinkPathPrefix: "/etc/asset-files-download-link",
    resetPasswordEndUserPathPrefix: "/end_user/enduser-reset-password",
    resetPasswordUserPathPrefix: "/admin/reset-password",
    verifyEmailEndUserPathPrefix: "/end_user/enduser-verify-email",
    verifyEmailUserPathPrefix: "/admin/verify-email",
}

